<template>
  <v-app>
    <v-app-bar app color="pink lighten-2 accent-1" dark dense>
      嘉基陪探病登錄系統
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
